export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يوجد حساب DutyPay في HubSystem لعنوان البريد الإلكتروني هذا."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يوجد حساب DutyPay في HubSystem لعنوان البريد الإلكتروني هذا."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل عنوان البريد الإلكتروني"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عنوان البريد الإلكتروني"])}
          }
        }
      },
      "ar-DZ": {
        "notification": {
          "hasUser": {
            "asyncError": {
              
            }
          },
          "checkUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "userDoesNotExist": {
            
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل عنوان البريد الإلكتروني"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عنوان البريد الإلكتروني"])}
          }
        }
      },
      "ar-EG": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يوجد حساب DutyPay في HubSystem لعنوان البريد الإلكتروني هذا."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يوجد حساب DutyPay في HubSystem لعنوان البريد الإلكتروني هذا."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل عنوان البريد الإلكتروني"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عنوان البريد الإلكتروني"])}
          }
        }
      },
      "ar-LB": {
        "notification": {
          "hasUser": {
            "asyncError": {
              
            }
          },
          "checkUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "userDoesNotExist": {
            
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل عنوان البريد الإلكتروني"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عنوان البريد الإلكتروني"])}
          }
        }
      },
      "ar-MA": {
        "notification": {
          "hasUser": {
            "asyncError": {
              
            }
          },
          "checkUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "userDoesNotExist": {
            
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل عنوان البريد الإلكتروني"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عنوان البريد الإلكتروني"])}
          }
        }
      },
      "ar-SA": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يوجد حساب DutyPay في HubSystem لعنوان البريد الإلكتروني هذا."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يوجد حساب DutyPay في HubSystem لعنوان البريد الإلكتروني هذا."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل عنوان البريد الإلكتروني"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عنوان البريد الإلكتروني"])}
          }
        }
      },
      "ar-SY": {
        "notification": {
          "hasUser": {
            "asyncError": {
              
            }
          },
          "checkUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "userDoesNotExist": {
            
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل عنوان البريد الإلكتروني"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عنوان البريد الإلكتروني"])}
          }
        }
      },
      "ar-TN": {
        "notification": {
          "hasUser": {
            "asyncError": {
              
            }
          },
          "checkUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          },
          "userDoesNotExist": {
            
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تسجيل الدخول"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل عنوان البريد الإلكتروني"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عنوان البريد الإلكتروني"])}
          }
        }
      },
      "bg-BG": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Няма акаунт в DutyPay в HubSystem за този имейл адрес."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Няма акаунт в DutyPay в HubSystem за този имейл адрес."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["вход"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["вход"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Въведете имейл адрес"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имейл адрес"])}
          }
        }
      },
      "bs-BA": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ne postoji DutyPay nalog u HubSystemu za ovu adresu e-pošte."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ne postoji DutyPay nalog u HubSystemu za ovu adresu e-pošte."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prijavi se"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prijavi se"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesi email adresu"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresa e-pošte"])}
          }
        }
      },
      "cs-CZ": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pro tuto e-mailovou adresu není v HubSystemu žádný účet DutyPay."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pro tuto e-mailovou adresu není v HubSystemu žádný účet DutyPay."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přihlášení"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přihlášení"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte emailovou adresu"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mailová adresa"])}
          }
        }
      },
      "da-DK": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der er ingen DutyPay-konto i HubSystemet for denne e-mailadresse."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der er ingen DutyPay-konto i HubSystemet for denne e-mailadresse."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Log på"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Log på"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indtast emailadresse"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mailadresse"])}
          }
        }
      },
      "de-DE": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zu dieser E-Mail-Adresse existiert kein DutyPay-Konto im HubSystem."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zu dieser E-Mail-Adresse existiert kein DutyPay-Konto im HubSystem."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anmelden"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anmelden"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Adresse eingeben"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Adresse"])}
          }
        }
      },
      "de-AT": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zu dieser E-Mail-Adresse existiert kein DutyPay-Konto im HubSystem."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zu dieser E-Mail-Adresse existiert kein DutyPay-Konto im HubSystem."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anmelden"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anmelden"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Adresse eingeben"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Adresse"])}
          }
        }
      },
      "de-CH": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zu dieser E-Mail-Adresse existiert kein DutyPay-Konto im HubSystem."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zu dieser E-Mail-Adresse existiert kein DutyPay-Konto im HubSystem."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anmelden"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anmelden"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Adresse eingeben"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Adresse"])}
          }
        }
      },
      "de-LU": {
        "notification": {
          "hasUser": {
            "asyncError": {
              
            }
          },
          "checkUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          },
          "userDoesNotExist": {
            
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anmelden"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anmelden"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Adresse eingeben"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Adresse"])}
          }
        }
      },
      "el-GR": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν υπάρχει λογαριασμός DutyPay στο HubSystem για αυτήν τη διεύθυνση ηλεκτρονικού ταχυδρομείου."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν υπάρχει λογαριασμός DutyPay στο HubSystem για αυτήν τη διεύθυνση ηλεκτρονικού ταχυδρομείου."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σύνδεση"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σύνδεση"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισάγετε διεύθυνση email"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διεύθυνση ηλεκτρονικού ταχυδρομείου"])}
          }
        }
      },
      "el-CY": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν υπάρχει λογαριασμός DutyPay στο HubSystem για αυτήν τη διεύθυνση ηλεκτρονικού ταχυδρομείου."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν υπάρχει λογαριασμός DutyPay στο HubSystem για αυτήν τη διεύθυνση ηλεκτρονικού ταχυδρομείου."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σύνδεση"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σύνδεση"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισάγετε διεύθυνση email"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διεύθυνση ηλεκτρονικού ταχυδρομείου"])}
          }
        }
      },
      "en-GB": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There is no DutyPay account in the HubSystem for this e-mail address."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There is no DutyPay account in the HubSystem for this e-mail address."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter email address"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email Address"])}
          }
        }
      },
      "en-IE": {
        "notification": {
          "hasUser": {
            "asyncError": {
              
            }
          },
          "checkUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          },
          "userDoesNotExist": {
            
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter email address"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email Address"])}
          }
        }
      },
      "en-US": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There is no DutyPay account in the HubSystem for this e-mail address."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There is no DutyPay account in the HubSystem for this e-mail address."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter email address"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email Address"])}
          }
        }
      },
      "es-ES": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No hay una cuenta de DutyPay en HubSystem para esta dirección de correo electrónico."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No hay una cuenta de DutyPay en HubSystem para esta dirección de correo electrónico."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iniciar sesión"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iniciar sesión"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduzca dirección de correo electrónico"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dirección de correo electrónico"])}
          }
        }
      },
      "et-EE": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selle e-posti aadressi jaoks pole HubSystemis DutyPay kontot."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selle e-posti aadressi jaoks pole HubSystemis DutyPay kontot."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logi sisse"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logi sisse"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sisesta e-posti aadress"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posti aadress"])}
          }
        }
      },
      "fi-FI": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["HubSystemissä ei ole DutyPay-tiliä tälle sähköpostiosoitteelle."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["HubSystemissä ei ole DutyPay-tiliä tälle sähköpostiosoitteelle."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sisäänkirjautuminen"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sisäänkirjautuminen"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Syötä sähköpostiosoite"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sähköpostiosoite"])}
          }
        }
      },
      "fr-BE": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il n'y a pas de compte DutyPay dans le HubSystem pour cette adresse e-mail."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il n'y a pas de compte DutyPay dans le HubSystem pour cette adresse e-mail."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connexion"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connexion"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez l'adresse e-mail"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail"])}
          }
        }
      },
      "fr-CH": {
        "notification": {
          "hasUser": {
            "asyncError": {
              
            }
          },
          "checkUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          },
          "userDoesNotExist": {
            
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connexion"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connexion"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez l'adresse e-mail"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail"])}
          }
        }
      },
      "fr-FR": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il n'y a pas de compte DutyPay dans le HubSystem pour cette adresse e-mail."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il n'y a pas de compte DutyPay dans le HubSystem pour cette adresse e-mail."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connexion"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connexion"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez l'adresse e-mail"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail"])}
          }
        }
      },
      "fr-LU": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il n'y a pas de compte DutyPay dans le HubSystem pour cette adresse e-mail."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il n'y a pas de compte DutyPay dans le HubSystem pour cette adresse e-mail."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connexion"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connexion"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez l'adresse e-mail"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail"])}
          }
        }
      },
      "ga-IE": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Níl aon chuntas DutyPay sa HubSystem don seoladh ríomhphoist seo."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Níl aon chuntas DutyPay sa HubSystem don seoladh ríomhphoist seo."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logáil isteach"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logáil isteach"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir isteach seoladh ríomhphoist"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seoladh ríomhphoist"])}
          }
        }
      },
      "he-IL": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אין חשבון DutyPay ב-HubSystem עבור כתובת דוא＂ל זו."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אין חשבון DutyPay ב-HubSystem עבור כתובת דוא＂ל זו."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["התחברות"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["התחברות"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הזן כתובת דוא＂ל"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["כתובת דוא＂ל"])}
          }
        }
      },
      "hi-IN": {
        "notification": {
          "hasUser": {
            "asyncError": {
              
            }
          },
          "checkUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["त्रुटि"])}
            }
          },
          "userDoesNotExist": {
            
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["लॉग इन"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["लॉग इन"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ईमेल पता दर्ज करें"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ईमेल पता"])}
          }
        }
      },
      "hr-HR": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ne postoji DutyPay račun u HubSystem za ovu adresu e-pošte."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ne postoji DutyPay račun u HubSystem za ovu adresu e-pošte."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prijavi se"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prijavi se"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesi email adresu"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresa e-pošte"])}
          }
        }
      },
      "hu-HU": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ehhez az e-mail címhez nincs DutyPay-fiók a HubSystemben."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ehhez az e-mail címhez nincs DutyPay-fiók a HubSystemben."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belépés"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Belépés"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adja meg az e-mail címet"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail-cím"])}
          }
        }
      },
      "it-CH": {
        "notification": {
          "hasUser": {
            "asyncError": {
              
            }
          },
          "checkUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          },
          "userDoesNotExist": {
            
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accedi"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accedi"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserisci l'indirizzo email"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indirizzo email"])}
          }
        }
      },
      "it-IT": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non esiste un account DutyPay in HubSystem per questo indirizzo e-mail."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non esiste un account DutyPay in HubSystem per questo indirizzo e-mail."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accedi"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accedi"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserisci l'indirizzo email"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indirizzo e-mail"])}
          }
        }
      },
      "ja-JP": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["HubSystem には、このメール アドレスの DutyPay アカウントがありません。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["HubSystem には、このメール アドレスの DutyPay アカウントがありません。"])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログインする"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログインする"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メールアドレスを入力してください"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["電子メールアドレス"])}
          }
        }
      },
      "ko-KR": {
        "notification": {
          "hasUser": {
            "asyncError": {
              
            }
          },
          "checkUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["오류"])}
            }
          },
          "userDoesNotExist": {
            
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["로그인"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["로그인"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["이메일 주소를 입력하세요"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["이메일 주소"])}
          }
        }
      },
      "lt-LT": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Šiam el. pašto adresui „HubSystem“ nėra „DutyPay“ paskyros."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Šiam el. pašto adresui „HubSystem“ nėra „DutyPay“ paskyros."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prisijungti"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prisijungti"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įveskite el. pašto adresą"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elektroninio pašto adresas"])}
          }
        }
      },
      "lv-LV": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Šai e-pasta adresei HubSystem nav DutyPay konta."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Šai e-pasta adresei HubSystem nav DutyPay konta."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pieslēgties"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pieslēgties"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ievadiet e-pasta adresi"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-pasta adrese"])}
          }
        }
      },
      "mt-MT": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["M'hemm l-ebda kont DutyPay fis-HubSystem għal dan l-indirizz elettroniku."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["M'hemm l-ebda kont DutyPay fis-HubSystem għal dan l-indirizz elettroniku."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Illoggja"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Illoggja"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Daħħal l-indirizz tal-email"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indirizz tal-posta elettronika"])}
          }
        }
      },
      "nb-NO": {
        "notification": {
          "hasUser": {
            "asyncError": {
              
            }
          },
          "checkUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Feil"])}
            }
          },
          "userDoesNotExist": {
            
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logg inn"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logg inn"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skriv inn epostadresse"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-postadresse"])}
          }
        }
      },
      "nl-BE": {
        "notification": {
          "hasUser": {
            "asyncError": {
              
            }
          },
          "checkUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          },
          "userDoesNotExist": {
            
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inloggen"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inloggen"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer e-mailadres in"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mailadres"])}
          }
        }
      },
      "nl-NL": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Er is geen DutyPay-account in het HubSystem voor dit e-mailadres."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Er is geen DutyPay-account in het HubSystem voor dit e-mailadres."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inloggen"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inloggen"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer e-mailadres in"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mailadres"])}
          }
        }
      },
      "pl-PL": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dla tego adresu e-mail nie ma konta DutyPay w HubSystem."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dla tego adresu e-mail nie ma konta DutyPay w HubSystem."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zaloguj się"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zaloguj się"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wprowadź adres e-mail"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adres e-mail"])}
          }
        }
      },
      "pt-PT": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Não há conta DutyPay no HubSystem para este endereço de e-mail."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Não há conta DutyPay no HubSystem para este endereço de e-mail."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iniciar sessão"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iniciar sessão"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Digite o endereço de e-mail"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Endereço de e-mail"])}
          }
        }
      },
      "ro-RO": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nu există niciun cont DutyPay în HubSystem pentru această adresă de e-mail."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nu există niciun cont DutyPay în HubSystem pentru această adresă de e-mail."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conectare"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conectare"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduceți adresa de email"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresa de e-mail"])}
          }
        }
      },
      "ru-RU": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Для этого адреса электронной почты в системе HubSystem нет учетной записи DutyPay."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Для этого адреса электронной почты в системе HubSystem нет учетной записи DutyPay."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вход"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вход"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите адрес электронной почты"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Адрес электронной почты"])}
          }
        }
      },
      "sk-SK": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pre túto e-mailovú adresu nie je v HubSystem žiadny účet DutyPay."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pre túto e-mailovú adresu nie je v HubSystem žiadny účet DutyPay."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prihlásenie"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prihlásenie"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadajte e-mailovú adresu"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mailová adresa"])}
          }
        }
      },
      "sl-SI": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Za ta e-poštni naslov v sistemu HubSystem ni računa DutyPay."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Za ta e-poštni naslov v sistemu HubSystem ni računa DutyPay."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prijava"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prijava"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vnesite e-poštni naslov"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-poštni naslov"])}
          }
        }
      },
      "sv-SE": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Det finns inget DutyPay-konto i HubSystem för den här e-postadressen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Det finns inget DutyPay-konto i HubSystem för den här e-postadressen."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logga in"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logga in"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ange e-postadress"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-postadress"])}
          }
        }
      },
      "th-TH": {
        "notification": {
          "hasUser": {
            "asyncError": {
              
            }
          },
          "checkUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ความผิดพลาด"])}
            }
          },
          "userDoesNotExist": {
            
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["เข้าสู่ระบบ"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["เข้าสู่ระบบ"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ป้อนที่อยู่อีเมล"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ที่อยู่อีเมล"])}
          }
        }
      },
      "tr-CY": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["HubSystem'de bu e-posta adresi için bir DutyPay hesabı yok."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["HubSystem'de bu e-posta adresi için bir DutyPay hesabı yok."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oturum aç"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oturum aç"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta adresini giriniz"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta adresi"])}
          }
        }
      },
      "tr-TR": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["HubSystem'de bu e-posta adresi için bir DutyPay hesabı yok."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["HubSystem'de bu e-posta adresi için bir DutyPay hesabı yok."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oturum aç"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oturum aç"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta adresini giriniz"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta adresi"])}
          }
        }
      },
      "uk-UA": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Помилка"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["У системі HubSystem немає облікового запису DutyPay для цієї електронної адреси."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Помилка"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["У системі HubSystem немає облікового запису DutyPay для цієї електронної адреси."])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Помилка"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Анмельден"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Анмельден"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введіть адресу електронної пошти"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Електронна адреса"])}
          }
        }
      },
      "vi-VN": {
        "notification": {
          "hasUser": {
            "asyncError": {
              
            }
          },
          "checkUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lỗi"])}
            }
          },
          "userDoesNotExist": {
            
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Đăng nhập"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Đăng nhập"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nhập địa chỉ email"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Địa chỉ email"])}
          }
        }
      },
      "zh-CN": {
        "notification": {
          "hasUser": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            }
          },
          "checkUser": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["该电子邮件地址在 HubSystem 中没有 DutyPay 帐户。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            }
          },
          "userDoesNotExist": {
            "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["该电子邮件地址在 HubSystem 中没有 DutyPay 帐户。"])},
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
          }
        },
        "emailForm": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登录"])},
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登录"])}
        },
        "email": {
          "input": {
            "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入电子邮件地址"])},
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电子邮件地址"])}
          }
        }
      }
    }
  })
}
